/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef, useLayoutEffect, createRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './style.scss'
import {
    CButton,
    CCard,
    CCardBody,
    CCardGroup,
    CCol,
    CContainer,
    CForm,
    CFormInput,
    CInputGroup,
    CRow,
    CFormLabel,
} from '@coreui/react'
import { loginRequest, loginReset, registerRequest, registerSendVerifictionCode, sendVerifictionCode, verificationReset } from '../../../../service/actions/userActions'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom';
import { resetProps } from '../../../../service/actions/userActions'
import '../../auth/style.scss'
import { getDomainActionRequest } from '../../../../service/actions/domainActions'
import { activePackageForUserAction, getPackageByPackageIdAction, getPackegeById, resetPackagePropsAction } from '../../../../service/actions/packageAction'
import jwt_decode from "jwt-decode";
import RoleEnum from '../../../../Enums/Roles'
import verificationRight from '../../../../assets/images/verificationRight.png'
import verificationLeft from '../../../../assets/images/verificationLeft.png'
import topImage from '../../../../assets/images/topImage.png'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { VerifyCodeSVG } from '../../../../components/IconSvg'
import { checkForNumericEnFaString, checkForNumericFaString, enToPersianChar, toEnglishNumber } from '../../../../components/helper'
import { toast } from 'react-toastify'

const validPaths = ['login', 'register', 'getPassword'];
const GetVerificationCode = ({
    user,
    onSuccessSendVerifiction,
    onSuccessPostRegisterverifiction,
    onWaiting,
    Token,
    domain,
    successGetDomain,
    successGetPackage,
    listData,
    userEmail,
    getPackageByPackageIdResult,
    activatedPackage,
    successPackageActivation,
    registerPostEmailSuccess,
    loginPostEmailSuccess


}) => {

    const { t, i18n } = useTranslation()
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const ref = useRef();
    const numerOfInputs = 6;


    const [validated, setValidated] = useState(false)
    const [widthScreen, setWidthScreen] = useState(window.innerWidth)
    const [minutes, setMinutes] = useState(1);
    const [seconds, setSeconds] = useState(0);
    const [verificationCode, setVerificationCode] = useState("");
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPressBackSpace, setIsPressBackSpace] = useState(false)
    const [inputRefsArray] = useState(() => Array.from({ length: numerOfInputs }, () => createRef()));
    const [letters, setLetters] = useState(() => Array.from({ length: numerOfInputs }, () => ""));
    const [indexChange, setIndexChange] = useState()
    // const [email, setEmail] = useState('')

    let direction = i18n.dir()


    // useEffect(() => {
    //     setEmail(userEmail)
    // }, [userEmail])


    useLayoutEffect(() => {

        if (!validPaths.includes(location?.state?.from)) {
            navigate("/login");
        }

        function updateSize() {
            setWidthScreen([window.innerWidth]);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        dispatch(resetProps())
        return () => {
            dispatch(resetProps())
            dispatch(resetPackagePropsAction());
            window.removeEventListener('resize', updateSize);
        }
    }, []);

    useEffect(() => {

        if (successPackageActivation) {

            dispatch(resetPackagePropsAction())

            if (activatedPackage.isActive) {
                navigate('/setDomain', { state: { package: activatedPackage } })
            } else {

                navigate(`/payment/${activatedPackage?.packageType.invoiceIdWHMCS}`,
                    {
                        state: {
                            package: getPackageByPackageIdResult,
                            packageId: location.state.packageId,
                            duration: getPackageByPackageIdResult.durations.find(i => i.id === location.state.durationId)

                        }
                    })
            }

        }
    }, [successPackageActivation])

    useEffect(() => {
        if (registerPostEmailSuccess ||
            loginPostEmailSuccess) {
            setMinutes(1)
            setSeconds(0)

            dispatch(loginReset())
            dispatch(registerRequest())

        }
    }, [registerPostEmailSuccess,
        loginPostEmailSuccess])


    useEffect(() => {
        if (getPackageByPackageIdResult) {

            dispatch(activePackageForUserAction(
                {
                    userId: user.userId,
                    Currency: "IRR",
                    durationCount: 1,
                    packageTypeId: location.state.packageId,
                    durationId: location.state.durationId,
                    isActive: true,
                    featureIds: getPackageByPackageIdResult.features.map(item => item.id)
                }
            ))
            dispatch(resetPackagePropsAction())

        }

    }, [getPackageByPackageIdResult])



    // useEffect(() => {
    //     if (successGetDomain) {
    //         const decodedToken = jwt_decode(user.token)
    //         if (listData.data.length === 0 && decodedToken.role === RoleEnum.User) {

    //             if (location.state.packageId) {
    //                 dispatch(getPackageByPackageIdAction(location.state.packageId))

    //             } else {
    //                 navigate(`/packageWizard`, { state: { from: 'auth', user: user } })
    //             }
    //         } else {
    //             navigate("/")
    //             // if (location.state.from === 'login') {
    //             //     if (domain?.length > 0) {
    //             //         navigate("/")
    //             //     } else {
    //             //         navigate("/setDomain")

    //             //     }
    //             // } else {
    //             //     navigate("/setDomain")
    //             // }
    //         }
    //     }
    // }, [successGetDomain])

    // useEffect(() => {
    //     if (successGetPackage) {
    //         dispatch(getDomainActionRequest())
    //         dispatch(resetPackagePropsAction())
    //     }
    // }, [successGetPackage]);

    useEffect(() => {
        if (indexChange === 5) {
            let isEmpty = false
            letters.map((item, index) => {
                if (item === '') {
                    isEmpty = true
                }
            })

            if (!isEmpty) {
                handleVerificationCode()
            }
        }
    }, [letters])

    useEffect(() => {

        if (onSuccessSendVerifiction || onSuccessPostRegisterverifiction) {
            const saveCategorySelectOptions = new Promise((resolve) => {
                localStorage.setItem("sipOnlineUser", JSON.stringify(user))
                localStorage.setItem("accessToken", user.token)
                resolve("Saved");
            });
            saveCategorySelectOptions.then(() => {

                if (location.state.from === 'register' && location.state.packageId) {
                    dispatch(getPackageByPackageIdAction(location.state.packageId))

                } else
                    if (location.state.from === 'register' && !location.state.packageId) {
                        navigate(`/packageWizard`, { state: { from: 'auth', user: user } })

                    } else {
                        ///-- At QA request, the user enters the wizard only after registration

                        navigate("/")

                    }
                // else if (location.state.from === 'getPassword') {
                //     navigate("/profile", { state: { from: 'getPassword' } })
                // } else if (localStorage.getItem("sipOnlineSkipWizard") === user.userId.toString() && !location.state.packageId) {
                //     navigate("/")
                // } else {
                //     const today = new Date();
                //     var todayDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
                //     dispatch(getPackegeById({
                //         whereConditionText: `packageExpiration > \"${todayDate}\"`,
                //         sortText: "",
                //         pageSize: 10,
                //         pageNumber: 1,
                //         disablePaging: true
                //     }, user.userId))

                // }





            });
        }

    }, [onSuccessSendVerifiction, onSuccessPostRegisterverifiction])

    useEffect(() => {
        dispatch(resetProps())

        if (inputRefsArray?.[0]?.current) {
            inputRefsArray?.[0]?.current?.focus();
        }

        const BackspacePress = (event) => {
            if (event.key === "Backspace") {
                setTimeout(() => {
                    setIsPressBackSpace(true)

                    handleKeyDown()
                }, 100)

            }

            if (event.keyCode === 35) {
                setCurrentIndex(5)
                const nextInput = inputRefsArray?.[5]?.current;
                nextInput.focus();
                nextInput.select();
            }
            if (event.keyCode === 36) {
                setCurrentIndex(0)

                const nextInput = inputRefsArray?.[0]?.current;
                nextInput.focus();
                nextInput.select();
            }
        };

        window.addEventListener("keydown", BackspacePress)
        return () => {
            setIsPressBackSpace(false)
            window.removeEventListener("keydown", BackspacePress);
        }

    }, []);


    useEffect(() => {
        let myInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(myInterval)
                } else {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
            }
        }, 1000)
        return () => {
            clearInterval(myInterval);
        };
    })

    const handleVerificationCode = (e, _letters) => {
        if (e !== undefined) {
            e.preventDefault()
        }

        let verificationCodeTotal = _letters ? _letters : ''

        if (verificationCodeTotal === '') {
            letters.forEach((item, index) => {
                let newItem = checkForNumericFaString(item) ? toEnglishNumber(item) : item
                verificationCodeTotal = verificationCodeTotal + newItem
            })

        }


        if (verificationCodeTotal !== '') {
            if (location.state.from === 'register') {
                dispatch(registerSendVerifictionCode({ email: userEmail, verificationCode: verificationCodeTotal }));
            }
            else if (location.state.from === 'login' || location.state.from === 'getPassword') {
                dispatch(sendVerifictionCode({ email: userEmail, verificationCode: verificationCodeTotal }));
            }
        }
        else {
            toast.error(t("ERROR_VERIFICATION_CODE"))
        }

    }


    const onChange = (e, index) => {
        setIndexChange(index)
        const { value } = e.target;

        setLetters((letters) =>
            letters.map((letter, letterIndex) =>
                letterIndex === index ? value : letter
            )
        )
        if (isPressBackSpace) {
            setIsPressBackSpace(false)
        }

        if (value !== "") {
            const nextIndex = currentIndex < numerOfInputs - 1 ? currentIndex + 1 : 0;
            inputRefsArray?.[nextIndex]?.current.focus();
            inputRefsArray?.[nextIndex]?.current.select()
            setCurrentIndex(nextIndex)
        }
    }

    const onClick = (e, index) => {
        setCurrentIndex(index);
        e.target.select();
    }

    const handleKeyDown = () => {

        setCurrentIndex((prevIndex) => {
            let nextIndex = ''
            if (prevIndex > 0) {
                nextIndex = prevIndex <= numerOfInputs - 1 ? prevIndex - 1 : 0;
            }
            else {
                nextIndex = prevIndex;
            }
            const nextInput = inputRefsArray?.[nextIndex]?.current;
            nextInput.focus();
            nextInput.select();
            return nextIndex;
        });

    }

    const agianCode = (e) => {
        console.log(location, "location")
        if (location.state?.from === "register") {
            dispatch(registerRequest({ email: userEmail }));
        }
        if (location.state?.from === "login") {
            dispatch(loginRequest({ email: userEmail }));
        }

        e.preventDefault()

    }

    const changeLanguage = () => {
        if (direction === 'rtl') {
            i18n.changeLanguage('en')
        }
        else {
            i18n.changeLanguage('fa')
        }

    }

    const getFromClipboard = (e) => {
        e.preventDefault();
        if (e.clipboardData.getData('text')) {
            const temp = e.clipboardData.getData('text').toString()
            setLetters([...temp.split('')])
            handleVerificationCode(undefined, temp)
        }
    }



    return (
        <div className={`d-flex flex-row  auth-form `}>
            <div className='section-right' >
                <div className='d-flex flex-row justify-content-between head-tools-context' >
                    <span className='btn btn-default main-page-btn' type="button" onClick={(e) => navigate('/login')}>{t('EDIT_EMAIL')}</span>
                    <div className='d-flex flex-column justify-content-start' >
                        <div className='d-flex flex-row justify-content-end'>
                            <button className='btn btn-default main-page-btn' style={{ width: '40px' }} onClick={changeLanguage} >{direction === 'ltr' ? 'فا' : 'En'}</button>
                        </div>
                        <img className="top-image" src={topImage} alt="" />
                    </div>
                </div>
                <div className='d-flex flex-row justify-content-center' >
                    <div className='login-section '>
                        <div className='icon-login d-flex flex-row justify-content-center'><VerifyCodeSVG /></div>
                        <h4 className='icon-title d-flex flex-row justify-content-center'><b>{t('ACTIVATED_CODE')}</b></h4>
                        <p className='login-email-enter d-flex flex-row justify-content-center'>{t('DESCRIPTION.GETVERIFICATIONCODE.VERIFICATIONCODE_HERE', { email: userEmail })}</p>
                        <CForm onSubmit={handleVerificationCode} noValidate validated={validated} className="verification-code-form" >
                            <div className='d-flex flex-row justify-content-between  btn-verify-holder' style={{ direction: 'ltr' }}
                            >
                                {inputRefsArray.map((ref, index) => {
                                    return (
                                        <input
                                            onPaste={(e) => getFromClipboard(e)}
                                            key={index}
                                            ref={ref}
                                            type={widthScreen > 900 ? "text" : "number"}
                                            id={`box${index}-1`}
                                            onChange={(e) => { onChange(e, index) }}
                                            onClick={(e) => { onClick(e, index) }}
                                            value={letters[index]}
                                            max={"1"}
                                            maxLength={1}
                                            autoComplete="xyz123"
                                            name='new-code'
                                        />

                                    );
                                })
                                }
                            </div>
                            <div className='d-flex flex-row'>
                                <button className="btn btn-primary submit-verify-btn " disabled={onWaiting} type="submit" >
                                    {/* {onWaiting ?
                                        <div className="spinner-border" role="status" aria-hidden="true"></div>
                                        : t('CHECK_CODE')} */}
                                    {t('CHECK_CODE')}
                                </button>
                            </div>
                            <div className="d-flex flex-row  justify-content-center check-time">
                                {minutes === 0 && seconds === 0 ?
                                    <p onClick={(e) => { agianCode(e) }} className='cursor-pointer' title={t('ACTION.AGAINCODE')}>{t('ACTION.AGAINCODE')}</p> :
                                    <p >{`${i18n.language === 'fa' ? enToPersianChar(minutes) : minutes}:${i18n.language === 'fa' ? enToPersianChar(seconds) : seconds}`}</p>}
                            </div>
                            <div className='Copywriter d-flex flex-row justify-content-center' style={{ direction: 'ltr' }}>
                                <p>{t('COPY_WRITE')}</p>
                            </div>
                        </CForm>

                    </div>
                </div>



            </div>

            {widthScreen > 900 ? <div className={`image-container verification-code`}>
                <div className={`${i18n.language === 'fa' ? 'fa' : 'en'}`}></div>

                {/* <img className='section-left-img' style={i18n.language === 'fa' ? { left: '25px' } : { right: '25px' }} src={i18n.language === 'fa' ? verificationRight : verificationLeft} alt="" /> */}
            </div>
                : ''}

        </div>
    )
}

GetVerificationCode.propTypes = {

    user: PropTypes.object,
    onSuccessSendVerifiction: PropTypes.bool,
    onSuccessPostRegisterverifiction: PropTypes.bool,
    onWaiting: PropTypes.bool,
    Token: PropTypes.string,

    domain: PropTypes.array,
    successGetDomain: PropTypes.bool,


    success: PropTypes.bool,
    listData: PropTypes.object,
    userEmail: PropTypes.string
}

const mapStateToProps = (state) => ({

    user: state.userReducer.user,
    onSuccessSendVerifiction: state.userReducer.sendVeridictionCodeSuccess,
    onSuccessPostRegisterverifiction: state.userReducer.sendRegisterVerifictionCodeSuccess,
    onWaiting: state.userReducer.Waiting,
    Token: state.userReducer.Token,

    domain: state.domainReducer.domain,
    successGetDomain: state.domainReducer.successGetDomain,

    listData: state.packageReducer.listData,
    successGetPackage: state.packageReducer.success,
    userEmail: state.changeState.userEmail,
    getPackageByPackageIdResult: state.packageReducer.getPackageByPackageIdResult,
    successPackageActivation: state.packageReducer.activePackageSuccess,
    activatedPackage: state.packageReducer.activatedPackage,
    loginPostEmailSuccess: state.userReducer.loginPostEmailSuccess,
    registerPostEmailSuccess: state.userReducer.registerPostEmailSuccess,





})

export default connect(mapStateToProps)(GetVerificationCode)



